import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Collapse,
  Alert,
  FormControl,
  InputLabel,
  Select as MUISelect,
  MenuItem,
  Link
} from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Select from "react-select";
import axios from "axios";
import EDMSFiles from "../UI/EDMSFiles";
import GhostTextCompletion from "../UI/TextPrediction";
import VitalsChart from "../UI/VitalChart";
import Paginate from "../UI/paginate";
import notification from "../../utility/notification";
import { get, post } from "../../utility/fetch";
import { useNavigate } from "react-router-dom";
import { Edit } from "@mui/icons-material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(1)
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#17621A',
  color: 'white',
  '&:hover': {
    backgroundColor: '#124E15',
  },
  marginTop: theme.spacing(2)
}));

function VitalsTreat({ treatment, patientId, firstVitals }) {

  const [documentArray, setDocumentArray] = useState([]);

  const [payload, setPayload] = useState({
    dateOfVisit: "",
    temperature: "",
    bloodPressure: "",
    heartPulse: "",
    respiratory: "",
    height: 0,
    weight: 0,
    bmi: 0, // Added BMI to the payload
    careType: 0,
    vitalNurseEmployeeId: 0,
    appointmentId: null,
    treatmentId: 0,
    serviceTreatmentId: treatment?.id || 0,
    doctorId: treatment?.doctorId,
    notes: "",
    vitalDocuments: [],
    bloodSugar: '',
    oxygenSaturation: '',

  });
  console.log(treatment)

  const [nurses, setNurses] = useState([]);
  const [docNames, setDocNames] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [visits, setVisits] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [Appointments, setAppointments] = useState([]);
  const [viewing, setViewing] = useState(false);
  const [selectedMfiles, setSelectedMfiles] = useState([]);
  const [add, setAdd] = useState(false)
  const [appointmentPassed, setAppointmentPassed] = useState(false);
  const [isServicePaid, setIsServicePaid] = useState(true);
  const [vitalServicesFromAppointmentId, setVtalServicesFromAppointmentId] =
    useState();
  const [showChart, setShowChart] = useState(false); // State to toggle chart visibility
  const navigate = useNavigate();
  const [category, setCategory] = useState({ name: "Select Category", value: "" });
  const [service, setService] = useState({ name: "Select Service", value: "" });
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const submitServicePayload = async () => {
    try {
      let res = await post("/patients/CreateVitalServicePayment", {
        clinicId: +sessionStorage.getItem("clinicId"),
        categoryId: category.value,
        patientId: +patientId,
        categoryItemId: service.value,
        amount: 0,
        status: "Pending",
        appointmentId: Number(treatment?.appointmentId),
      });
      console.log(res);
      if (res.message === "The Vital service record was added successfully") {
        notification({ message: 'The service was added successfully', type: "success" });
        setCategory({ name: "Select Category", value: "" });
        setService({ name: "Select Service", value: "" });
        setSelectedCategory(null);
      }
      // notification({ message: "Unauthorized Session", type: "error" });
    } catch (error) {
      console.log(error);
      notification({ message: "Failed to add service to treatment", type: "error" });
    }
  };

  const getVitalsByAppointmentId = async (id) => {
    try {
      let res = await get(
        `/patients/vital-service-by-appointmentId?appointmentId=${id}`
      );
      setIsServicePaid(
        res.data.find(
          (e) => e.status === "Not Paid" || e.status === "Advance Paid"
        )
      );

      setVtalServicesFromAppointmentId(res.data);
      // setVtalServicesFromAppointmentId()
      // setTotalPages(res.pageCount);
    } catch (error) {
      console.error("Error fetching visitation details:", error);
    }
  };

  const handleSelectChange = useCallback((value, name) => {
    if (name === "category") {
      setCategory(value);
    } else {
      setService(value);
      setPayload((prevPayload) => ({
        ...prevPayload,
        serviceId: value?.value,
      }));
    }
  }, []);

  const deleteDoc = (doc) => {
    let newArr = documentArray.filter((id) => id.name !== doc);
    setDocumentArray(newArr);
  };

  const handleEdit = (recordId) => {
    setViewing(parseInt(recordId));
    setAdd(true);
  }

  const closeModal = () => {
    setAdd(false)
  };

  const fieldLabels = {
    dateOfVisit: "Visit Date",
    temperature: "Temperature",
    bloodPressure: "Blood Pressure",
    heartPulse: "Heart Pulse",
    respiratory: "Respiratory",
    vitalNurseEmployeeId: "Assigned Nurse",
    appointmentId: 'Appointment',
    notes: "Notes",
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    const parsedValue = ["height", "weight", "temperature", "heartPulse", 'vitalNurseEmployeeId'].includes(name)
      ? parseFloat(value)
      : value;

    setPayload((prevPayload) => {
      const updatedPayload = { ...prevPayload, [name]: parsedValue };

      if (name === "height" || name === "weight") {
        const heightInMeters = updatedPayload.height / 100;
        const weight = updatedPayload.weight;

        if (heightInMeters > 0 && weight > 0) {
          // multiply by 100, round to nearest integer, then divide back
          const rawBmi = weight / (heightInMeters ** 2);
          updatedPayload.bmi = Math.round(rawBmi * 100) / 100;
        } else {
          updatedPayload.bmi = 0;
        }
      }

      return updatedPayload;
    });

  };

  const getNurses = async () => {
    try {
      let res = await get(`/patients/Allnurse/${sessionStorage.getItem("clinicId")}?pageIndex=1&Pagesize=300`);
      let tempNurses = res?.data
        ?.filter((nurse) => nurse?.username)
        .map((nurse) => {
          return { name: nurse?.username, value: parseFloat(nurse?.employeeId) };
        });

      tempNurses?.unshift({ name: "Select Nurse", value: "" });
      setNurses(tempNurses);
    } catch (error) {
      console.error("Error fetching nurses:", error);
    }
  };


  const getDoctors = async () => {
    try {
      let res = await get(`/patients/AllDoctor/${sessionStorage.getItem("clinicId")}?pageIndex=1&Pagesize=300`);
      let tempDoc = res?.data
        ?.filter((doc) => doc?.username)
        .map((doc) => {
          return { name: doc?.username, value: parseFloat(doc?.employeeId) };
        });

      tempDoc?.unshift({ name: "Select Doctor", value: "" });
      setDoctors(tempDoc);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };


  const getVitalsDetails = async (currentPage) => {
    try {
      let res = await get(`/patients/GetVitalsByServiceTreatmentId?treatmentId=${treatment?.id}&pageIndex=${currentPage}&Pagesize=10`);
      setVisits(res.data);
      setTotalPages(res.pageCount)

    } catch (error) {
      console.error("Error fetching visitation details:", error);
    }
  };

  const validatePayload = () => {
    let validationErrors = {};
    let missingFields = [];

    Object.keys(fieldLabels).forEach((field) => {
      if (field === 'appointmentId') {
        return;
      }

      if (!payload[field]) {
        validationErrors[field] = `${fieldLabels[field]} is required`;
        missingFields.push(fieldLabels[field]);
      }
    });

    if (missingFields.length > 0) {
      const errorMessage = `The following fields are required: ${missingFields.join(", ")}`;
      notification({ message: errorMessage, type: "error" });
    }

    return Object.keys(validationErrors).length === 0;
  };


  const careTypes = [
    { name: "Select Care Type", value: "" },
    { name: "In patient", value: 1 },
    { name: "Out patient", value: 2 },
  ];

  const submitPayload = async () => {
    if (!validatePayload()) {
      return;
    }

    const currentDate = new Date();
    const hours = currentDate.getHours().toString().padStart(2, "0");
    const minutes = currentDate.getMinutes().toString().padStart(2, "0");
    const timeString = `${hours}:${minutes}`;

    const dateTimeOfVisit = `${payload.dateOfVisit} ${timeString}`;

    const vitalDocs = [
      ...(documentArray?.map((doc) => ({
        docName: doc?.name,
        docPath: doc?.path,
      })) || []),
      {
        docName: selectedMfiles?.fileName,
        docPath: selectedMfiles?.filePath,
      }
    ];

    setLoading(true);

    try {
      let res = await post("/patients/AddTreatmentVitalsRecord", {
        ...payload,
        dateOfVisit: dateTimeOfVisit,
        clinicId: Number(sessionStorage.getItem("clinicId")),
        patientId: parseFloat(patientId),
        appointmentId: Number(treatment?.appointmentId),
        doctorId: Number(treatment?.doctorId),
        careType: 2,
        treatmentId: 0,
        serviceTreatmentId: treatment?.id || 0,
        // vitalNurseEmployeeId: Number(sessionStorage.getItem('userId')),
        vitalDocuments: vitalDocs,
      });

      if (res.message === "The Vital record was added successfully") {
        notification({ message: res.message, type: "success" });
        setPayload({
          dateOfVisit: "",
          temperature: "",
          bloodPressure: "",
          heartPulse: "",
          respiratory: "",
          height: "",
          weight: "",
          careType: 0,
          vitalNurseEmployeeId: 0,
          appointmentId: null,
          notes: "",
          docName: "",
          docPath: "",
          bloodSugar: '',
          oxygenSaturation: '',
          vitalDocuments: [],
        })
        setSelectedMfiles([]);
        setDocumentArray([]);
        getVitalsDetails(currentPage);
        return
      } else if (res.StatusCode === 401) {
        notification({ message: "Unauthorized Session", type: "error" });
      } else if (res.StatusCode === 500) {
        notification({ message: "Internal Server Error", type: "error" });
      } else {
        let errorMessage = "Failed to add Vitals ";

        if (res && res.errors) {
          const errors = res.errors;
          const customFieldNames = {
            vitalNurseEmployeeId: "Assigned Nurse",
            // appointmentId: 'Appointment',
          };

          const missingFields = Object.keys(errors).filter((field) => {
            return errors[field].some((errorMsg) => /is required/i.test(errorMsg));
          });
          if (missingFields.length > 0) {
            const formattedFields = missingFields.map((field) => {
              if (customFieldNames[field]) {
                return customFieldNames[field];
              }
              return field.replace(/([a-z])([A-Z])/g, "$1 $2");
            });

            errorMessage = `The following fields are required: ${formattedFields.join(", ")}`;
          }
        }
        console.log(res)
        notification({ message: errorMessage, type: "error" });
      }
    } catch (error) {
      console.error("Error adding vital record:", error);
      // notification({ message: "Failed to add Vital record", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await get(`/appointment/get-appointment-bypatientId/${patientId}?pageIndex=${1}&Pagesize=1000`);

      let tempDoc = response?.data
        ?.filter(item => item?.tracking === 'AwaitingVitals')
        ?.map((item, idx) => {
          const appointTime = item?.appointTime === '00:00' ? '(Visit)' : `at ${item?.appointTime}`;
          const doctorText = item?.doctorId ? `with ${item?.doctor}` : '';

          return {
            name: `${item?.appointDate} ${appointTime} ${doctorText}`.trim(),
            value: parseFloat(item?.id)
          };
        });


      tempDoc?.unshift({ name: "Select Appointment", value: "" });
      setAppointments(tempDoc);
      setPayload(prevPayload => ({ ...prevPayload, appointmentId: '' }))
      setAppointmentPassed(false);

    } catch (e) {
    }
  };

  const getCategories = async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("Token not found in session storage");
      return;
    }

    const options = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/healthfinanceapi/api/category/list/1/1000`,
        options
      );

      const tempServices = res?.data?.resultList
        // ?.filter((service) => service.category.name === "Clinical Service" || service.category.name === "Clinical Services")
        .map((category) => ({
          label: category?.name,
          value: parseFloat(category?.id),
        }));

      tempServices?.unshift({ label: "Select Service", value: "" });

      setCategories(tempServices);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const getCategoriesService = async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("Token not found in session storage");
      return;
    }

    const options = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      setService({});
      setServices(null);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/healthfinanceapi/api/categoryitem/list/category/${category?.value}/1/1000`,
        options
      );

      const tempServices = res?.data?.resultList.map((service) => ({
        label: service?.itemName,
        value: parseFloat(service?.id),
      }));

      tempServices?.unshift({ label: "Select Service", value: "" });

      setServices(tempServices);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const deleteVisit = async (id) => {
    if (!window.confirm('Are you sure you want to delete this vital record?')) {
      return;
    }
  
    try {
      const response = await post('/patients/DeleteTreatmentVitalsRecord', {
        id: id,
        clinicId: sessionStorage.getItem('clinicId')
      });
  
      if (response.message === "The Vital record was deleted successfully") {
        notification({ message: 'Vital record deleted successfully', type: 'success' });
        getVitalsDetails(currentPage); // Refresh the vitals list
      } else {
        notification({ message: 'Failed to delete vital record', type: 'error' });
      }
    } catch (error) {
      console.error('Error deleting vital record:', error);
      notification({ 
        message: 'An error occurred while deleting the vital record', 
        type: 'error' 
      });
    }
  };

  const toggleChart = () => {
    setShowChart((prev) => !prev); // Toggle chart visibility
  };

  useEffect(() => {
    getCategories()
    getNurses();
    getDoctors();
    fetchData();
    getVitalsByAppointmentId(treatment?.appointmentId);
    getVitalsDetails(currentPage);
  }, []);

  useEffect(() => {
    getVitalsDetails(currentPage);
  }, [currentPage]);

  useEffect(() => {
    getCategoriesService();
  }, [category]);

  const combinedVitals = [ firstVitals, ...visits ];


  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={3}>
        {/* Left Column */}
        <Grid item xs={12} md={4}>
          <StyledPaper elevation={2}>
            <Typography variant="h6" gutterBottom>
              Vitals Information
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="date"
                  label="Date"
                  name="dateOfVisit"
                  value={payload.dateOfVisit}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Temperature"
                  name="temperature"
                  value={payload.temperature}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Blood Pressure"
                  name="bloodPressure"
                  value={payload.bloodPressure}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Heart Pulse"
                  name="heartPulse"
                  value={payload.heartPulse}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Respiratory"
                  name="respiratory"
                  value={payload.respiratory}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Blood Sugar"
                  name="bloodSugar"
                  value={payload.bloodSugar}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Oxygen Saturation"
                  name="oxygenSaturation"
                  value={payload.oxygenSaturation}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Height (cm)"
                  name="height"
                  value={payload.height}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Weight (kg)"
                  name="weight"
                  value={payload.weight}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="BMI"
                  name="bmi"
                  value={payload.bmi || ""}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Assign Nurse</InputLabel>
                  <MUISelect
                    value={payload.vitalNurseEmployeeId}
                    onChange={handleChange}
                    name="vitalNurseEmployeeId"
                  >
                    {nurses.map((nurse) => (
                      <MenuItem key={nurse.value} value={nurse.value}>
                        {nurse.name}
                      </MenuItem>
                    ))}
                  </MUISelect>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Documents
                  </Typography>
                  <EDMSFiles
                    selectedFile={selectedMfiles}
                    setSelectedFile={setSelectedMfiles}
                  />
                  {documentArray?.map((item, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                      <Link href={item.path} target="_blank" sx={{ mr: 1 }}>
                        {item.name}
                      </Link>
                      <IconButton size="small" onClick={() => deleteDoc(item.name)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              </Grid>

              <Grid item xs={12}>
                <GhostTextCompletion
                  label="Notes"
                  name="notes"
                  value={payload.notes}
                  handleChange={handleChange}
                />
              </Grid>
            </Grid>

            <StyledButton 
              fullWidth
              variant="contained"
              onClick={submitPayload}
              disabled={loading}
            >
              Add Vital
            </StyledButton>
          </StyledPaper>
        </Grid>

        {/* Right Column */}
        <Grid item xs={12} md={8}>
          <StyledPaper elevation={2}>
            <Typography variant="h6" gutterBottom>
              Services
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Select
                  value={category}
                  onChange={(e) => handleSelectChange(e, "category")}
                  options={categories}
                  placeholder="Select Category"
                />
              </Grid>

              {Array.isArray(services) && (
                <Grid item xs={12}>
                  <Select
                    value={service}
                    onChange={(e) => handleSelectChange(e, "serviceId")}
                    options={services}
                    placeholder="Select Service"
                  />
                </Grid>
              )}
            </Grid>

            <StyledButton
              variant="contained"
              onClick={submitServicePayload}
              disabled={loading || !category?.value || !service?.value}
            >
              Add Service
            </StyledButton>
          </StyledPaper>

          <StyledPaper elevation={2}>
            <Typography variant="h6" gutterBottom>
              Vitals History
            </Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Temperature</TableCell>
                    <TableCell>Blood Pressure</TableCell>
                    <TableCell>Heart Pulse</TableCell>
                    <TableCell>Respiratory</TableCell>
                    <TableCell>BMI</TableCell>
                    <TableCell>Assigned Nurse</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {visits.map((visit, index) => (
                    <TableRow key={index}>
                      <TableCell>{new Date(visit.dateOfVisit).toLocaleString()}</TableCell>
                      <TableCell>{visit.temperature}</TableCell>
                      <TableCell>{visit.bloodPressure}</TableCell>
                      <TableCell>{visit.heartPulse}</TableCell>
                      <TableCell>{visit.respiratory}</TableCell>
                      <TableCell>{visit.bmi}</TableCell>
                      <TableCell>{visit.assignedNurse}</TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={() => handleEdit(visit.id)}>
                          <Edit />
                        </IconButton>
                        <IconButton size="small" onClick={() => deleteVisit(visit.id)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ mt: 3 }}>
              <StyledButton 
                onClick={toggleChart}
                endIcon={showChart ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              >
                {showChart ? "Hide Vitals Chart" : "Show Vitals Chart"}
              </StyledButton>
              <Collapse in={showChart}>
                <Box sx={{ mt: 2 }}>
                  <VitalsChart visitsData={combinedVitals} />
                </Box>
              </Collapse>
            </Box>

            <Box sx={{ mt: 2 }}>
              <Paginate
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </Box>
          </StyledPaper>
        </Grid>
      </Grid>
    </Box>
  );
}

// Styled component for UnpaidServices
const UnpaidServices = styled(({ payload, unpaidServices, isServicePaid }) => {
  const [showTable, setShowTable] = useState(false);

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      {showTable ? (
        payload?.appointmentId && (
          <Alert 
            severity="warning"
            action={
              <Button color="inherit" size="small" onClick={() => setShowTable(true)}>
                View
              </Button>
            }
          >
            You have one or more unpaid services.
          </Alert>
        )
      ) : (
        isServicePaid && (
          <StyledPaper>
            <Typography variant="h6" gutterBottom>
              Added Services
            </Typography>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Category</TableCell>
                    <TableCell>Service</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {unpaidServices?.map((service, index) => (
                    <TableRow key={index}>
                      <TableCell>{service.categoryName}</TableCell>
                      <TableCell>{service.categoryItem}</TableCell>
                      <TableCell>{service.status}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </StyledPaper>
        )
      )}
    </Box>
  );
})``;

export default VitalsTreat;